import { render, staticRenderFns } from "./SupportChat.vue?vue&type=template&id=322de4aa"
import script from "./SupportChat.vue?vue&type=script&lang=js"
export * from "./SupportChat.vue?vue&type=script&lang=js"
import style0 from "./SupportChat.vue?vue&type=style&index=0&id=322de4aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports